import React from 'react';
import './About.css';

const About: React.FC = () => {
  const stats = [
    { number: '100,000+', label: '服务人数' },
    { number: '600+', label: '项目活动' },
    { number: '10年+', label: '行业经验' },
    { number: '2,000+', label: '会员人数' },
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="about-title">公司简介</h2>
            <p className="about-description">
              深圳市高帝思教育咨询有限公司成立于2019年，前身为2015年创立的"妈妈益呀"公益项目，是一家突破时代的教育科技创新型"社会企业"！
            </p>
            <p className="about-description">
              "高帝思"将艺术疗愈，心脑科技与心理教育完美融合，为个人，学校，企业，社区，各类组织提供专业的心理教育提升服务。
            </p>
            <p className="about-description">
              同时"高帝思 "聚合全球顶尖人才，整合资源，搭建特色化心理教育专业平台，推动艺术疗愈在家庭教育、学校教育、社会教育等领域的应用。
            </p>
            <p className="about-description">
              "高帝思"致力于用公益的理念、商业的模式、金融的工具、科技的手段，解决社会问题，推动社会进步！
            </p>
          </div>

          <div className="about-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
